import { Component } from '@angular/core';
import {DxButtonModule, DxTextBoxModule} from 'devextreme-angular';
import {TranslocoDirective} from '@jsverse/transloco';
import {Router, RouterLink} from '@angular/router';
import {Auth} from '../../services/auth.service';
import {ErrorMessage} from '../../components/error-message/error-message/error-message.component';

@Component({
  selector: 'app-login',
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    TranslocoDirective,
    ErrorMessage
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class Login {
  constructor(public auth: Auth, public router: Router) {}

  // Form fields for username and password input
  username: string = '';
  password: string = '';
  loginButtonDisabled: boolean = false;

  // Toast properties for displaying feedback messages
  toastMessage: string = '';       // The message to display in the toast

  /**
   * Triggered when the user submits the login form.
   * Checks for filled username and password fields, then attempts login via AuthService.
   * Displays success feedback and navigates on successful login; shows an error toast on failure.
   */
  onSubmit() {
    // Verify both username and password are provided
    if (this.username && this.password) {
      // Disable the login button while we wait for the callback
      this.loginButtonDisabled = true;
      // Call login method from AuthService with entered credentials
      this.auth.authenticateUser(this.username, this.password).then(loginSuccess => {
          if (loginSuccess) {
            this.closeError();
            // Navigate to home on successful login
            this.router.navigate(['']);
          }
          else {
            // Show error message if login fails
            this.showError('Message-LoginIncorrect');
          }
        })
        .catch(err => {
          if(err.status === 401) {
            this.showError('Message-LoginIncorrect');
          }
          else {
            this.showError("Message-LoginError");
          }
        })
        .finally(() => this.loginButtonDisabled = false);

    } else {
      // Show error message if username or password is missing
      this.showError('Message-LoginMissing');
    }
  }

  /**
   * Displays the error message.
   * @param message - ID of the text to display in the toast
   */
  showError(message: string) {
    // Set toast properties based on parameters
    this.toastMessage = message;
  }

  /**
   * Resets the displayed error message.
   */
  closeError() {
    this.toastMessage = '';
  }
}
